const legacyPathRedirects = [
    {
        legacyPattern: /^\/reviewing\/(?<claimId>[^/]+)\/?$/iu,
        replacement: '/claim/$<claimId>/review',
    },
];

const rollbackPathMappings = [
    {
        pattern: /^\/claim\/(?<claimId>[^/]+)\/review\/?$/iu,
        legacyReplacement: '/reviewing/$<claimId>',
    },
    {
        pattern: /^\/claim\/(?<claimId>[^/]+)\/export\/?$/iu,
        legacyReplacement: '/claim/$<claimId>/review',
    },
];

const isInsurerHostname = (): boolean =>
    globalThis.location.hostname.split('.')[0].endsWith('insurer');

export const isLegacySurePartHostname = (): boolean =>
    globalThis.location.hostname.split('.')[0].endsWith('surepart');

export const getSurePartBaseUrl = (): string => (isInsurerHostname() ? '/surepart' : '/');

export const toSurePartUrl = (pathname: string): string => {
    const baseUrl = getSurePartBaseUrl();
    return baseUrl === '/' ? pathname : `${baseUrl}${pathname}`;
};

export const toLegacySurePartPath = (pathname: string): string => {
    const mapping = rollbackPathMappings.find(({ pattern }) => pattern.test(pathname));
    return mapping ? pathname.replace(mapping.pattern, mapping.legacyReplacement) : pathname;
};

const toCanonicalSurePartPath = (pathname: string): string => {
    const redirect = legacyPathRedirects.find(({ legacyPattern }) => legacyPattern.test(pathname));
    return redirect ? pathname.replace(redirect.legacyPattern, redirect.replacement) : pathname;
};

const hasSurePartPath = (): boolean =>
    globalThis.location.pathname === '/surepart' ||
    globalThis.location.pathname.startsWith('/surepart/');

export const normaliseSurePartUrl = (baseUrl: string): void => {
    const hasPrefix = hasSurePartPath();
    const unprefixedPathname = hasPrefix
        ? globalThis.location.pathname.slice('/surepart'.length) || '/'
        : globalThis.location.pathname;
    const pathname = isLegacySurePartHostname()
        ? toCanonicalSurePartPath(unprefixedPathname)
        : unprefixedPathname;
    const canonicalPathname = baseUrl === '/surepart' ? `${baseUrl}${pathname}` : pathname;
    if (canonicalPathname === globalThis.location.pathname) {
        return;
    }

    globalThis.history.replaceState(
        null,
        '',
        `${canonicalPathname}${globalThis.location.search}${globalThis.location.hash}`,
    );
};
